import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TokenService } from 'src/app/core/token/token.service';

@Component({
  selector: 'app-modal-trial',
  templateUrl: './modal-trial.component.html',
  styleUrls: ['./modal-trial.component.scss']
})
export class ModalTrialComponent implements OnInit {
  @Input() emailData;
  dias_restantes: number = 0;
  selector: string;

  constructor(
    public modal: NgbActiveModal,
    public translate: TranslateService,
    private tokenService: TokenService,
    private elemRef: ElementRef,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    let tkn: any;
    tkn = this.tokenService.getAllInfos();
    this.dias_restantes = tkn.empresa.tempo_restante_trial;
  }

  close(result?) {
    this.modal.close(result);
  }
}